import OrganisationCodeForm from './OrganisationCodeForm'
import enhance from './OrganisationCodeForm.enhancer'

export default enhance(OrganisationCodeForm)



// WEBPACK FOOTER //
// ./src/components/organisms/OrganisationCodeForm/index.js